import React from 'react'

const Filter = (props) => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill={props.color ? props.color : '#1D79FB'}
         className={props.className ? props.className : ''} xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M4.90034 8.60329L0.110555 1.07574C-0.185947 0.609766 0.148748 0 0.701022 0H13.299C13.8513 0 14.1859 0.609766 13.8894 1.07574L9.09966 8.60329V11.8992C9.09966 12.1644 8.94988 12.4067 8.71277 12.5253L5.91323 13.9252C5.44787 14.1579 4.90034 13.8195 4.90034 13.2991V8.60329ZM1.97607 1.40009L6.19078 8.02385C6.26224 8.13615 6.3002 8.26651 6.3002 8.39963V12.1668L7.69997 11.4668V8.39963C7.69997 8.26651 7.73793 8.13615 7.80939 8.02385L12.0241 1.40009H1.97607Z"
        />
    </svg>
)

export default Filter
